import { loadStripe } from '@stripe/stripe-js'
import Button from '@admin/components/button'
import { useState } from 'react'
import PropTypes from 'prop-types'
import React from 'react'

const StripeFinancialConnectionsButton = ({ onSuccess, onFailure, className, label }, { network }) => {
  const [processing, setProcessing] = useState(false)

  const handleConnect = () => {
    setProcessing(true)

    // Create fresh session only when user clicks
    network.request({
      endpoint: '/api/admin/team/affiliate/bank/session',
      method: 'GET',
      onSuccess: async ({ data }) => {
        try {
          // Load Stripe with connected account if provided (production)
          const options = data.stripe_account ? { stripeAccount: data.stripe_account } : {}
          const stripe = await loadStripe(process.env.STRIPE_API_KEY, options)

          const result = await stripe.collectFinancialConnectionsAccounts({
            clientSecret: data.client_secret
          })

          if (result.error) {
            throw new Error(result.error.message)
          }

          network.request({
            endpoint: '/api/admin/team/affiliate/bank/verify',
            method: 'POST',
            body: {
              financial_connections_account: result.financialConnectionsSession.accounts[0].id
            },
            onSuccess: ({ data }) => {
              setProcessing(false)
              if (onSuccess) onSuccess(data)
            },
            onFailure: (error) => {
              setProcessing(false)
              if (onFailure) {
                onFailure(error)
              } else {
                console.error('Financial Connections verify error:', error)
              }
            }
          })
        } catch (error) {
          setProcessing(false)
          if (onFailure) {
            onFailure(error)
          } else {
            console.error('Financial Connections error:', error)
          }
        }
      },
      onFailure: (error) => {
        setProcessing(false)
        if (onFailure) {
          onFailure(error)
        } else {
          console.error('Session creation error:', error)
        }
      }
    })
  }

  const buttonProps = {
    label: label || 'Connect Bank Account',
    className: className || 'link',
    loading: processing,
    disabled: processing,
    handler: handleConnect
  }

  return <Button { ...buttonProps } />
}

StripeFinancialConnectionsButton.propTypes = {
  onSuccess: PropTypes.func,
  onFailure: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string
}

StripeFinancialConnectionsButton.contextTypes = {
  network: PropTypes.object
}

export default StripeFinancialConnectionsButton
